<div class="error-dialog-container">
  <div class="dismiss-button-placeholder">
    <button mat-icon-button (click)="dismiss()"><img src="assets/icons/x_grey.svg" alt="Close dialog" /></button>
  </div>
  <div class="warning-icon-placeholder">
    <img src="assets/icons/warning_blue.svg" alt="Warning image" />
  </div>
  <h1>{{ model.title | translate }}</h1>
  <p>{{ model.description | translate }}</p>
  @if (model.message) {
    <div class="error-message-placeholder">
      <p>{{ model.message }}</p>
    </div>
  }
  <div class="accept-button-placeholder">
    <button color="primary" mat-flat-button (click)="dismiss()">{{ model.button | translate }}</button>
  </div>
</div>
